/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListCreateDto } from '../../models/sales-quote-price-list-create-dto';
import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';

export interface QuotePriceListsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesQuotePriceListCreateDto
}

export function quotePriceListsControllerCreate(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuotePriceListResponseDto>;
    })
  );
}

quotePriceListsControllerCreate.PATH = '/o2-sales/quote-price-lists/{tenant}';
